<template>
	<div style="display: contents;">
		<template v-if="buttonComponent == 'v-btn'">
            <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                        v-on="{ ...tooltip }"
						:fab="button.params.fab ? button.params.fab : false"
						:icon="button.params.fab ? false : true"
						:small="button.params.small ? true : false"
						:fixed="button.params.fixed ? true : false"
						:bottom="button.params.bottom ? true : false"
						:right="button.params.right ? true : false"
						:dark="button.params.dark ? true : false"
						:color="button.params.button_color ? button.params.button_color : ''"
						@click="openDialog()">
                        <v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="params ? params.color : ''">{{ button.params.icon ? button.params.icon : 'mdi-content-copy' }}</v-icon>
					</v-btn>
				</template>
        		<span>{{ button.params.tooltip ? button.params.tooltip : 'Duplica Progetto' }}</span>
    		</v-tooltip>
		</template>

		<v-list-item v-else-if="buttonComponent == 'v-list-item'"
            dense 
            :disabled="disabled"
            @click.stop="openDialog()"
            ripple>
            <v-list-item-icon>
                <v-icon style="font-size: 18px">{{ button.params.icon ? button.params.icon : 'mdi-content-copy' }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ button.params.tooltip ? button.params.tooltip : 'Duplica Progetto' }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        
        <v-dialog v-model="show" max-width="900" persistent class="round-card" scrollable>
            <v-card class="background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Duplica Progetto</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="px-1 pb-1">
                    <v-container v-if="show" fluid class="px-6 pt-6">
                        <div class="pt-2 body-2">Vuoi duplicare questo progetto?</div>
                        <v-switch
                            v-model="duplicate_taskboard"
                            persistent-hint
                            hint="Se attivo anche il taskbord sarà duplicato nel nuovo progetto"
                            inset
                            label="Duplica Taskboard"
                        ></v-switch>
                        
                        <v-switch v-if="duplicate_taskboard && $store.getters.checkSettings('products_association_task')"
                            v-model="duplicate_task_products"
                            persistent-hint
                            hint="Se attivo anche i prodotti nei task saranno duplicati nel nuovo progetto"
                            inset
                            label="Duplica Prodotti"
                        ></v-switch>
                        
                        <!-- <v-switch v-if="duplicate_taskboard"
                            v-model="duplicate_attachments"
                            persistent-hint
                            hint="Includi nella duplica gli allegati del progetto e dei relativi task"
                            inset
                            label="Includi allegati"
                        ></v-switch> -->
                    </v-container>

                </v-card-text>

                <v-divider></v-divider>
                
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="info" @click.native.stop="closeDialog()">Annulla
                    </v-btn>
                    <v-btn text color="primary" @click.native.stop="duplicate()" :loading="loading">Conferma
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

    export default {
        name: 'duplicate-project-component',
        components: {
        },
        props: {
            button: Object,
            buttonComponent: {type: String, default : 'v-btn'},
            id: Number,
            model: Object,
            modelDef: String,
            params: Object,
            disabled: Boolean
        },

        data() {
            return {
                show: false,
                loading: false,
                duplicate_taskboard: true,
                duplicate_task_products: false,
                duplicate_attachments: false
            }
        },

        methods: {

            closeDialog() {
                this.show = false
            },

            openDialog() {
                this.show = true
                this.$set(this, 'duplicate_taskboard', true)
            },

            duplicate() {
                if(!this.duplicate_taskboard) {
                    this.duplicate_task_products = false
                }
                let objectData = {
                    'duplicate_taskboard': this.duplicate_taskboard,
                    'duplicate_task_products': this.duplicate_task_products,
                    'duplicate_attachments': this.duplicate_attachments,
                }
                this.loading = true
                this.axios.post('projects-duplicate/' + this.id, objectData).then(response => {
                    // get body data
                        this.$store.commit('setSnackbar', {
                            timeout: 6000,
                            text: 'Progetto duplicato',
                            value: true,
                            color: 'success'
                        })

                        this.loading = false
                        this.$eventBusUtility.goTo(this.$router, 'projects-show', response.data['project_id'])

                }, response => {
                    this.loading = false
                })
            }
           
        },
    }
</script>